export default {
  step1: {
    title: '提交申请',
    subtitle: '已于12月21日提交',
    rules: '发票开具规则',
    rule1:
      '1、申请开票后，电子发票在1～3个工作日内开具；增值税专用发票（纸质）如资质审核通过，将在电子发票开具后10个工作日内为您寄出；',
    rule2: '2、开票金额为您实际支付金额；',
    rule3: '3、如有疑问请直接联系：13300001111。',
    contractName: '合同名称',
    contractTips: '请选择合同名称',
    invoiceType: '发票类型',
    amount: '开票金额',
    submit: '提交申请',
  },
  step2: {
    title: '电子信息',
    subtitle: '如有疑问联系客服',
    invoiceTitle: '发票抬头',
    taxNum: '纳税人识别号',
    address: '地址',
    bank: '开户行',
    bankAccount: '银行账号',
    email: '邮箱',
    tel: '手机号',
    titlePlaceholder: '请输入电子信息',
    subtitlePlaceholder: '请输入如有疑问联系客服',
    invoiceTitlePlaceholder: '请输入发票抬头',
    taxNumPlaceholder: '请输入纳税人识别号',
    addressPlaceholder: '请输入地址',
    bankPlaceholder: '请输入开户行',
    bankAccountPlaceholder: '请输入银行账号',
    emailPlaceholder: '请输入邮箱',
    telPlaceholder: '请输入手机号',
  },
  step3: {
    title: '发票已邮寄',
    subtitle: '电子发票开出后联系',
    consignee: '收货人',
    mobileNum: '手机号码',
    deliveryAddress: '收货地址',
    fullAddress: '详细地址',
  },
  step4: {
    title: '完成申请',
    subtitle: '如有疑问联系客服',
    finishTitle: '完成开票申请',
    finishTips: '预计1～3个工作日会将电子发票发至邮箱，发票邮寄请耐心等待',
    reapply: '再次申请',
    check: '查看进度',
  },
  preStep: '上一步',
  nextStep: '下一步',
};
